import { useEffect, useRef, useState } from 'react'
import { CircularProgress } from '@mui/material'
import { BaseFeedbackConIcona, BaseLinearProgressConPercentuale, BasePopoverConfermaOperazione } from 'feedback'
import { BaseButtons } from 'inputs'
import { BaseScatola, BaseGridLayout } from 'layout'
import { BaseTesto } from 'text'
import { useCoda } from 'utils'

export default function FeedbackCaricamentoFileMultipli(props) {
  const {
    fileDaCaricare,
    onFileCaricati,
    useGestioneFile,
    calcolaAltreInfoPerUpload,
  } = props

  const [caricamentoInCorso, setCaricamentoInCorso] = useState(false)
  const [fileConSuccesso, setFileConSuccesso] = useState([])
  const [fileFalliti, setFileFalliti] = useState([])

  const { uploadFile, ScatolaMessaggi } = useGestioneFile()

  const {
    primoElementoInCoda: fileCorrente,
    aggiungiInCoda,
    eliminaDallaCoda,
    isCodaVuota,
  } = useCoda(fileDaCaricare)

  async function caricaSingolo() {
    if (isCodaVuota()) {
      setCaricamentoInCorso(false)
      if (fileFalliti.length === 0) setTimeout(terminaCaricamento, 2000)
      return
    }

    setCaricamentoInCorso(true)
    const { ok } = await uploadFile(fileCorrente, {
      uuid: fileCorrente.uuid,
      ...calcolaAltreInfoPerUpload(fileCorrente)
    })

    if (ok) {
      setFileConSuccesso(fileEsistenti => [...fileEsistenti, fileCorrente])
    } else {
      setFileFalliti(fileEsistenti => [...fileEsistenti, fileCorrente])
    }
    eliminaDallaCoda(fileCorrente)
  }

  const caricaSingolo_Ref = useRef(caricaSingolo)
  caricaSingolo_Ref.current = caricaSingolo

  useEffect(() => {
    caricaSingolo_Ref.current()
  }, [fileCorrente])

  function terminaCaricamento() {
    onFileCaricati(fileConSuccesso)
  }

  function riprovaFalliti() {
    fileFalliti.forEach(file => aggiungiInCoda(file))
    setFileFalliti([])
  }

  return (
    <>
      {caricamentoInCorso &&
        <BaseGridLayout alignCenter justifyCenter sx={{ mb: 2 }}>
          <i>caricamento in corso</i>
          <CircularProgress size={25} />
        </BaseGridLayout>
      }

      <BaseLinearProgressConPercentuale
        percentualeCompletata={fileConSuccesso.length / fileDaCaricare.length * 100}
      />

      {fileConSuccesso.length > 0 &&
        <BaseGridLayout justifyCenter>
          <BaseFeedbackConIcona.TuttoOk
            messaggio={`${fileConSuccesso.length} su ${fileDaCaricare.length} file caricati con successo`}
          />
        </BaseGridLayout>
      }

      {caricamentoInCorso &&
        <BasePopoverConfermaOperazione
          messaggio='Le immagini non ancora caricate saranno scartate. Confermare?'
          onConferma={terminaCaricamento}
        >
          <BaseButtons.Custom
            testo='Interrompi e termina'
            color='default'
          />
        </BasePopoverConfermaOperazione>
      }

      {fileFalliti.length > 0 &&
        <BaseScatola outlined sx={{ borderColor: 'error.main', my: 2 }}>
          <BaseGridLayout justifyCenter>
            <BaseFeedbackConIcona.Errore
              messaggio={`Caricamento fallito per i seguenti ${fileFalliti.length} file:`}
            />
          </BaseGridLayout>
          {fileFalliti.map(({ uuid, name }) =>
            <BaseTesto piccolo key={uuid}>{name}</BaseTesto>
          )}
          {!caricamentoInCorso &&
            <BaseGridLayout justifyCenter>
              <BaseButtons.Custom
                testo='Riprova'
                onClick={riprovaFalliti}
              />
              <BaseButtons.Custom
                testo='Ignora e termina'
                color='default'
                onClick={terminaCaricamento}
              />
            </BaseGridLayout>
          }
        </BaseScatola>
      }

      {ScatolaMessaggi}
    </>
  )
}